import Sobre from '../components/Sobre'

let routes = {
    path: '/sobre',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/sobre',
            name: 'Sobre',
            component: Sobre
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/sobre.js